var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path, _path2, _g10, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFantasyOld = function SvgFantasyOld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 738,
    height: 181,
    fill: "none",
    viewBox: "0 0 738 181"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M713.741 6.46c-22.61 0-55.575 49.685-58.045 68.02-.57 4.275-.665 7.505 3.135 7.505 1.33 0 1.805.57 1.615 1.9l-.475 2.28c-.19 1.33-.855 1.9-2.185 1.9q-10.403-.998-21.09 0c-.665 0-1.9-.19-1.615-1.9l.475-2.28c.19-1.33.855-1.9 2.185-1.9 3.61 0 4.845-3.135 5.795-7.505.665-3.135.475-1.615 1.14-5.605.285-1.33.19-2.47-.19-3.705l-9.31-24.605c-1.52-4.275-3.325-6.27-5.51-6.27-1.33 0-1.805-.57-1.52-1.9l.57-2.28c.285-1.33.95-1.9 2.28-1.9 5.32.38 15.865.665 21.565 0 .665 0 1.71.19 1.425 1.9l-.57 2.28c-.285 1.33-.95 1.9-2.28 1.9-4.275 0-4.37 3.99-3.705 6.175l5.225 16.34c.38 1.235.855 1.33 1.52.095C673.746 18.24 690.941 0 713.171 0c12.255 0 20.805 6.745 20.805 14.25 0 5.795-4.18 9.12-8.36 9.12-3.135 0-5.7-1.615-6.84-4.275 2.28 0 3.515-2.945 3.515-4.75 0-3.99-2.945-7.885-8.55-7.885"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M607.292 27.455c2.66 0 7.03.475 10.45 2.47l2.85-1.9c1.805-1.14 3.325-.38 3.895 1.71l3.42 12.16v.57c0 1.425-1.9 2.47-3.61 2.47-1.33 0-2.66-.57-3.325-1.71-2.945-4.94-6.745-8.93-13.205-8.93-3.325 0-7.695 1.9-7.695 6.27 0 9.025 23.275 14.345 23.275 30.59 0 11.97-10.735 18.715-23.18 18.715-9.5 0-21.66-3.8-21.66-13.68 0-6.175 4.655-9.31 8.835-9.31 2.47 0 4.94 1.045 6.27 3.8-2.375.665-3.8 2.66-3.8 4.94 0 3.895 3.325 7.79 10.45 7.79 6.175 0 9.88-3.8 9.88-8.645 0-11.685-23.465-15.01-23.465-30.78 0-10.925 11.305-16.53 20.615-16.53"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M567.881 30.115c.95 8.835 1.52 17.67 2.565 26.505l2.28 19.095c.57 4.465 2.28 6.27 5.13 6.27 1.33 0 1.805.57 1.52 1.9l-.57 2.28c-.285 1.33-.95 1.9-2.28 1.9-5.795-.38-13.775-.665-20.045 0-.665 0-1.9-.19-1.52-1.9l.57-2.28c.285-1.33.95-1.9 2.28-1.9 3.61 0 2.85-3.04 2.47-7.505l-.285-3.705c-.095-1.33-.665-1.9-1.995-1.9h-12.92c-1.33 0-2.185.475-2.66 1.71L539.951 76c-1.615 3.895-.95 5.985 3.23 5.985 1.33 0 1.805.57 1.52 1.9l-.57 2.28c-.285 1.33-.95 1.9-2.28 1.9-6.84-.665-12.16-.665-19.095 0-.665 0-1.9-.19-1.52-1.9l.57-2.28c.285-1.33.95-1.9 2.28-1.9 4.085 0 7.03-3.61 9.12-7.98l17.765-36.67c.665-1.71.475-3.04-1.33-3.04-.665 0-1.995-.19-1.615-1.9l.665-2.28c.38-1.33.855-1.9 2.185-1.9 4.465.38 12.825.285 14.82 0 1.33-.19 1.995.57 2.185 1.9M557.526 62.13c1.33 0 1.9-.57 1.805-1.9l-1.14-15.2-.665-5.985-9.975 21.375c-.57 1.235-.285 1.71 1.045 1.71z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M490.737 28.215c5.7.285 13.775.76 20.14.76 6.08 0 13.49-.38 20.805-.76 1.33-.095 2.375.38 2.755 1.71l4.085 14.82c.665 2.09-5.415 2.945-6.65.57-2.85-5.51-5.51-11.115-10.26-10.735-3.325.285-4.465 3.23-5.32 7.41-1.52 6.84-4.94 25.65-5.795 32.49-.665 4.275-.665 7.505 3.135 7.505 1.33 0 1.805.57 1.615 1.9l-.475 2.28c-.19 1.33-.855 1.9-2.185 1.9-7.03-.665-14.06-.665-21.28 0-.665 0-1.9-.19-1.615-1.9l.475-2.28c.19-1.33.855-1.9 2.185-1.9 3.61 0 4.94-3.135 5.795-7.505 1.615-6.84 4.845-25.65 5.795-32.49.665-4.845.285-7.41-3.61-7.41-4.56 0-9.215 5.605-11.685 10.64-1.14 2.375-7.6 1.71-6.65-.57l5.985-14.725c.57-1.235 1.425-1.805 2.755-1.71"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M468.854 85.785c-.285 1.995-1.33 1.805-8.93 1.9-1.33 0-2.185-.475-2.66-1.71-.285-1.14-9.975-30.97-16.72-45.885 0 .57-.095 1.14-.19 1.71-1.615 6.84-4.75 25.84-5.7 32.68-.57 4.275-.665 7.505 5.415 7.505 1.33 0 1.805.57 1.615 1.9l-.475 2.28c-.19 1.33-.855 1.9-2.185 1.9-7.03-.665-14.06-.665-21.28 0-.665 0-1.9-.19-1.615-1.9l.475-2.28c.19-1.33.855-1.9 2.185-1.9 4.75 0 7.125-3.135 8.075-7.505 1.52-6.84 4.75-25.84 5.7-32.68.57-4.37.475-7.505-5.415-7.505-.665 0-1.9-.19-1.615-1.9l.475-2.28c.19-1.33.855-1.9 2.185-1.9 2.565.285 12.635.855 19.475 0 1.9 0 2.375.475 2.945 1.615l13.68 37.43c1.425-7.6 3.61-20.615 4.275-25.46.665-4.37.475-7.505-5.415-7.505-.665 0-1.9-.19-1.615-1.9l.475-2.28c.19-1.33.855-1.9 2.185-1.9 6.745.665 13.775.665 21.28 0 1.33-.095 1.805.57 1.615 1.9l-.475 2.28c-.19 1.33-.855 1.9-2.185 1.9-4.845 0-7.22 3.135-8.075 7.505-2.945 12.54-5.89 31.73-7.505 43.985"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M406.548 30.115c.95 8.835 1.52 17.67 2.565 26.505l2.28 19.095c.57 4.465 2.28 6.27 5.13 6.27 1.33 0 1.805.57 1.52 1.9l-.57 2.28c-.285 1.33-.95 1.9-2.28 1.9-5.795-.38-13.775-.665-20.045 0-.665 0-1.9-.19-1.52-1.9l.57-2.28c.285-1.33.95-1.9 2.28-1.9 3.61 0 2.85-3.04 2.47-7.505l-.285-3.705c-.095-1.33-.665-1.9-1.995-1.9h-12.92c-1.33 0-2.185.475-2.66 1.71L378.618 76c-1.615 3.895-.95 5.985 3.23 5.985 1.33 0 1.805.57 1.52 1.9l-.57 2.28c-.285 1.33-.95 1.9-2.28 1.9-6.84-.665-12.16-.665-19.095 0-.665 0-1.9-.19-1.52-1.9l.57-2.28c.285-1.33.95-1.9 2.28-1.9 4.085 0 7.03-3.61 9.12-7.98l17.765-36.67c.665-1.71.475-3.04-1.33-3.04-.665 0-1.995-.19-1.615-1.9l.665-2.28c.38-1.33.855-1.9 2.185-1.9 4.465.38 12.825.285 14.82 0 1.33-.19 1.995.57 2.185 1.9M396.193 62.13c1.33 0 1.9-.57 1.805-1.9l-1.14-15.2-.665-5.985-9.975 21.375c-.57 1.235-.285 1.71 1.045 1.71z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M323.784 69.73c.855-4.94 4.56-24.32 5.035-27.74.665-4.37.475-7.505-3.135-7.505-.665 0-1.9-.19-1.615-1.9l.475-2.47c.19-1.33.855-1.9 2.185-1.9a487 487 0 0 0 37.24 0c1.33-.095 2.185.475 2.755 1.71l4.465 15.01c.665 2.09-4.56 2.945-5.795.57-2.755-5.32-8.075-11.02-15.01-11.02h-3.42c-3.705 0-4.845 3.135-5.795 7.505-.665 3.04-2.28 10.355-2.66 12.73-.285 1.33.19 1.9 1.52 1.9h5.985c1.33 0 3.515-1.425 3.895-2.945l.38-1.425c.285-1.33.855-1.9 2.185-1.9h3.42c1.33 0 1.995.57 1.615 1.9-1.33 4.94-2.755 11.21-2.945 15.865-.19 1.33-.855 1.9-2.185 1.9h-3.42c-1.33 0-1.9-.57-1.615-1.9l.38-1.71c.285-1.71-1.14-3.325-3.04-3.325h-5.7c-1.235 0-2.09.855-2.185 1.9l-1.045 6.08c-4.655 27.17-17.29 49.21-42.37 49.21-11.4 0-19.475-5.415-19.475-12.92 0-5.795 4.18-9.12 8.36-9.12 3.135 0 5.7 1.615 6.84 4.275-2.28 0-3.515 2.945-3.515 4.75 0 3.99 2.945 7.885 8.55 7.885 19.855 0 26.41-27.17 29.64-45.41"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M293.458 48.415c.65 6.045 1.04 12.09 1.755 18.135l1.56 13.065c.39 3.055 1.56 4.29 3.51 4.29.91 0 1.235.39 1.04 1.3l-.39 1.56c-.195.91-.65 1.3-1.56 1.3-3.965-.26-9.425-.455-13.715 0-.455 0-1.3-.13-1.04-1.3l.39-1.56c.195-.91.65-1.3 1.56-1.3 2.47 0 1.95-2.08 1.69-5.135l-.195-2.535c-.065-.91-.455-1.3-1.365-1.3h-8.84c-.91 0-1.495.325-1.82 1.17l-1.69 3.705c-1.105 2.665-.65 4.095 2.21 4.095.91 0 1.235.39 1.04 1.3l-.39 1.56c-.195.91-.65 1.3-1.56 1.3-4.68-.455-8.32-.455-13.065 0-.455 0-1.3-.13-1.04-1.3l.39-1.56c.195-.91.65-1.3 1.56-1.3 2.795 0 4.81-2.47 6.24-5.46l12.155-25.09c.455-1.17.325-2.08-.91-2.08-.455 0-1.365-.13-1.105-1.3l.455-1.56c.26-.91.585-1.3 1.495-1.3 3.055.26 8.775.195 10.14 0 .91-.13 1.365.39 1.495 1.3m-7.085 21.905c.91 0 1.3-.39 1.235-1.3l-.78-10.4-.455-4.095-6.825 14.625c-.39.845-.195 1.17.715 1.17z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M223.917 47.115c3.9.195 9.425.52 13.78.52 4.16 0 9.23-.26 14.235-.52.91-.065 1.625.26 1.885 1.17l2.795 10.14c.455 1.43-3.705 2.015-4.55.39-1.95-3.77-3.77-7.605-7.02-7.345-2.275.195-3.055 2.21-3.64 5.07-1.04 4.68-3.38 17.55-3.965 22.23-.455 2.925-.455 5.135 2.145 5.135.91 0 1.235.39 1.105 1.3l-.325 1.56c-.13.91-.585 1.3-1.495 1.3a78 78 0 0 0-14.56 0c-.455 0-1.3-.13-1.105-1.3l.325-1.56c.13-.91.585-1.3 1.495-1.3 2.47 0 3.38-2.145 3.965-5.135 1.105-4.68 3.315-17.55 3.965-22.23.455-3.315.195-5.07-2.47-5.07-3.12 0-6.305 3.835-7.995 7.28-.78 1.625-5.2 1.17-4.55-.39l4.095-10.075c.39-.845.975-1.235 1.885-1.17"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M176.414 71.1c0-12.61 9.75-24.635 24.05-24.635 9.945 0 17.615 6.305 17.615 18.07 0 12.48-9.62 24.635-23.79 24.635-10.4 0-17.875-6.435-17.875-18.07m23.725-20.475c-9.75 0-14.755 13.26-14.755 22.035 0 6.695 2.6 12.22 9.035 12.22 9.685 0 14.625-13.195 14.625-22.1 0-6.695-2.665-12.155-8.905-12.155"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M167.812 86.505c-.195 1.365-.91 1.235-6.11 1.3-.91 0-1.495-.325-1.82-1.17-.195-.78-6.825-21.19-11.44-31.395 0 .39-.065.78-.13 1.17-1.105 4.68-3.25 17.68-3.9 22.36-.39 2.925-.455 5.135 3.705 5.135.91 0 1.235.39 1.105 1.3l-.325 1.56c-.13.91-.585 1.3-1.495 1.3a78 78 0 0 0-14.56 0c-.455 0-1.3-.13-1.105-1.3l.325-1.56c.13-.91.585-1.3 1.495-1.3 3.25 0 4.875-2.145 5.525-5.135 1.04-4.68 3.25-17.68 3.9-22.36.39-2.99.325-5.135-3.705-5.135-.455 0-1.3-.13-1.105-1.3l.325-1.56c.13-.91.585-1.3 1.495-1.3 1.755.195 8.645.585 13.325 0 1.3 0 1.625.325 2.015 1.105l9.36 25.61c.975-5.2 2.47-14.105 2.925-17.42.455-2.99.325-5.135-3.705-5.135-.455 0-1.3-.13-1.105-1.3l.325-1.56c.13-.91.585-1.3 1.495-1.3 4.615.455 9.425.455 14.56 0 .91-.065 1.235.39 1.105 1.3l-.325 1.56c-.13.91-.585 1.3-1.495 1.3-3.315 0-4.94 2.145-5.525 5.135-2.015 8.58-4.03 21.71-5.135 30.095"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fantasy-old_svg__l)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fantasy-old_svg__m",
    width: 459,
    height: 58,
    x: 140,
    y: 123,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M599 123H140v58h459z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#fantasy-old_svg__m)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fantasy-old_svg__n",
    width: 459,
    height: 58,
    x: 140,
    y: 123,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M599 123H140v58h459z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff84ab",
    mask: "url(#fantasy-old_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m599 140.901-222.162-2.804c-.755 0-1.51.268-2.084.805a2.8 2.8 0 0 0-.845 1.969c0 .717.271 1.433.845 1.97a2.8 2.8 0 0 0 2.084.805L599 140.842zM140 140.901l222.162-2.804c.755 0 1.51.268 2.084.805.543.537.845 1.253.845 1.969s-.272 1.433-.845 1.97a2.8 2.8 0 0 1-2.084.805zM367.749 140.901c0-.954.785-1.73 1.751-1.73s1.751.776 1.751 1.73c0 .955-.785 1.731-1.751 1.731a1.74 1.74 0 0 1-1.751-1.731M369.5 181l-2.808-32.521a2.8 2.8 0 0 1 .815-2.386c.544-.537 1.268-.806 2.023-.806s1.45.269 2.023.806c.665.656.937 1.551.816 2.386L369.56 181zM369.5 123c1.389 2.148 4.59 9.159 2.295 12.352a2.87 2.87 0 0 1-2.295 1.134 2.87 2.87 0 0 1-2.295-1.134c-2.295-3.193.906-10.204 2.295-12.352"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff84ab",
    filter: "url(#fantasy-old_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.099 46.524c1.836 0 4.851.328 7.211 1.705l1.966-1.311c1.246-.787 2.294-.262 2.688 1.18l2.359 8.39v.393c0 .983-1.311 1.704-2.49 1.704-.918 0-1.836-.393-2.295-1.18-2.032-3.408-4.654-6.161-9.111-6.161-2.294 0-5.309 1.31-5.309 4.326 0 6.227 16.059 9.898 16.059 21.107 0 8.259-7.407 12.913-15.994 12.913-6.555 0-14.945-2.622-14.945-9.439 0-4.26 3.212-6.424 6.096-6.424 1.704 0 3.409.721 4.326 2.622-1.638.459-2.622 1.835-2.622 3.409 0 2.687 2.295 5.375 7.211 5.375 4.26 0 6.817-2.622 6.817-5.965 0-8.063-16.19-10.357-16.19-21.238 0-7.538 7.8-11.406 14.223-11.406M79.273 53.08c0-3.475 2.819-7.08 6.686-7.08 2.688 0 4.72 2.294 4.72 5.113 0 5.178-5.572 11.864-7.866 11.864-.721 0-1.115-.524-1.115-1.049 0-.262.066-.459.197-.655 1.573-1.639 1.9-2.753 1.9-3.343 0-.197-.065-.262-.065-.262-2.687 0-4.457-1.967-4.457-4.589M43.385 47.049c3.933.196 9.505.524 13.897.524 4.195 0 9.308-.262 14.355-.524.918-.066 1.639.262 1.9 1.18l2.82 10.225c.458 1.442-3.737 2.032-4.589.394-1.966-3.802-3.802-7.67-7.08-7.407-2.293.196-3.08 2.228-3.67 5.112-1.049 4.72-3.409 17.699-3.998 22.418-.46 2.95-.46 5.179 2.163 5.179.917 0 1.245.393 1.114 1.31l-.328 1.574c-.13.917-.59 1.31-1.507 1.31a78.5 78.5 0 0 0-14.683 0c-.46 0-1.311-.13-1.115-1.31l.328-1.574c.131-.917.59-1.31 1.508-1.31 2.49 0 3.408-2.164 3.998-5.179 1.114-4.72 3.343-17.698 3.999-22.418.459-3.343.196-5.112-2.491-5.112-3.147 0-6.358 3.867-8.063 7.341-.786 1.639-5.244 1.18-4.588-.393l4.13-10.16c.393-.852.983-1.246 1.9-1.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.143 88.345c-.459 0-1.31-.132-1.114-1.311l.328-1.574c.13-.917.59-1.31 1.507-1.31 2.491 0 3.343-2.164 3.999-5.179 1.049-4.72 3.343-17.83 3.998-22.549.394-3.015.328-5.178-2.163-5.178-.459 0-1.31-.131-1.114-1.311l.328-1.573c.13-.918.59-1.311 1.507-1.311 4.523.459 9.374.459 14.421 0 .918-.066 1.245.393 1.114 1.31l-.327 1.574c-.132.918-.59 1.311-1.508 1.311-2.556 0-3.343 2.163-3.998 5.178-1.05 4.72-3.344 17.83-3.999 22.55-.393 2.949-.459 5.178 2.163 5.178.918 0 1.246.393 1.115 1.31l-.328 1.574c-.131.917-.59 1.31-1.508 1.31a75.7 75.7 0 0 0-14.42 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__a",
    width: 113.91,
    height: 96.065,
    x: 624.066,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__b",
    width: 57.4,
    height: 70.415,
    x: 574.507,
    y: 27.455,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__c",
    width: 66.291,
    height: 67.879,
    x: 517.165,
    y: 28.186,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__d",
    width: 64.671,
    height: 67.862,
    x: 477.902,
    y: 28.203,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__e",
    width: 79.047,
    height: 67.859,
    x: 412.087,
    y: 28.206,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__f",
    width: 66.291,
    height: 67.879,
    x: 355.832,
    y: 28.186,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__g",
    width: 105.338,
    height: 100.065,
    x: 269.909,
    y: 28.205,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__h",
    width: 47.883,
    height: 48.97,
    x: 257.494,
    y: 47.095,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__i",
    width: 46.775,
    height: 48.958,
    x: 213.872,
    y: 47.107,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__j",
    width: 49.665,
    height: 50.705,
    x: 172.414,
    y: 46.465,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__k",
    width: 56.611,
    height: 48.956,
    x: 127.708,
    y: 47.109,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old_svg__o",
    width: 114.323,
    height: 51.59,
    x: 11,
    y: 46,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10930_7750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10930_7750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fantasy-old_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140 123h459v58H140z"
  })))));
};
export default SvgFantasyOld;